import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  paperContainer: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 4fr) minmax(0, 1fr)',
    gridTemplateRows: '1fr auto auto 1fr',
    columnGap: theme.spacing(3),
    rowGap: 0,
    alignItems: 'center',
    textAlign: 'left',
    width: '100%',
    padding: theme.spacing(1.5),
    maxHeight: '100%',
    border: 'none',
    borderRadius: 12,
    boxShadow: '0 16px 40px rgba(15, 23, 42, 0.18)',
  },
  title: {
    gridColumn: 1,
    gridRow: 2,
    minWidth: 0,
  },
  textBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    gridColumn: 1,
    gridRow: 3,
    minWidth: 0,
    marginTop: theme.spacing(1.5),
  },
  fixedActions: {
    display: 'flex',
    flexDirection: 'column-reverse',
    alignItems: 'stretch',
    justifyContent: 'center',
    gap: theme.spacing(1),
    gridColumn: 2,
    gridRow: '1 / -1',
  },
}))

export default useStyles
